/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { Script } from "gatsby";
import { ContentLoader } from "@trussle/external-components";
import { usePartnerContext } from "../Partner";
import { BACKGROUND_COLOR_PARTNER_MAP } from "./BackgroundColorPartner";
import "./styles.scss";
import { useIsInView } from "../../hooks/useIsInView";

export interface IProps {
  template: TrustpilotTemplates;
  className?: string;
  isInViewFromStart?: boolean;
}

export enum TrustpilotTemplates {
  Mini = "53aa8807dec7e10d38f59f32",
  MicroStar = "5419b732fbfb950b10de65e5",
  MicroCombo = "5419b6ffb0d04a076446a9af",
  Carousel = "53aa8912dec7e10d38f59f36",
  Slider = "54ad5defc6454f065c28af8b"
}

export const Trustpilot: React.FC<IProps> = ({ template, className, isInViewFromStart }) => {
  const [isError, setIsError] = React.useState(false);
  const { ref, isInView } = useIsInView(isInViewFromStart);

  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script pasted into <head /> in gatsby-browser.js isn't loaded just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [template]);

  const partner = usePartnerContext();
  const backgroundColor = BACKGROUND_COLOR_PARTNER_MAP[partner];

  return (
    <div className={className}>
      {isInView && (
        <Script
          onError={() => setIsError(true)}
          src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        />
      )}
      <div
        ref={ref}
        className="trustpilot-widget"
        data-template-id={template}
        data-businessunit-id="6392287740b116458553ed83"
        data-locale="en-GB"
        data-stars="4,5"
        data-schema-type="Organization"
        data-style-width="100%"
        data-style-height={
          template === TrustpilotTemplates.Slider ? "240px" : "auto"
        }
        css={{
          backgroundColor,
          margin: "auto",
        }}
      >
        {
          isError ? (
            <a
              className="trustpilot-link"
              href={`https://uk.trustpilot.com/review/${DOMAIN}`}
              target="_blank" // eslint-disable-line react/jsx-no-target-blank
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          ) : (
            <div className="content-loader-wrapper">
              <ContentLoader />
              <ContentLoader />
              <ContentLoader />
              <ContentLoader />
            </div>
          )
        }
      </div>
    </div>
  );
};
